import { projectDataType } from './project';

export const validateLocationName = (value: any) => {
    let validation = true;
    if (value != '' && value != undefined) {
        let rgp = /[^A-Za-x0-9]+/;
        if (value.match(rgp)) {
            validation = false;
        }
    }
    return validation;
};

export const getLocationTasks = (locations: any[]) => {
    let tasks: any[] = [];

    if (locations?.length > 0) {
        for (let index = 0; index < locations.length; index++) {
            const oneL = locations[index] as any;
            if (oneL?.Task?.length > 0) {
                for (let t = 0; t < oneL.Task.length; t++) {
                    tasks.push({
                        ...oneL.Task[t],
                        Location: { ...oneL, Task: [oneL.Task[t]], visible: true }
                    });
                }
            }
        }
    }
    return tasks;
};

export const getLocationDataTasks = (data: any) => {
    let tasks: any[] = getLocationTasks(data?.locations);
    return tasks;
};

export const preProcessPointsData = (points: any) => {
    const getItem = (item: any, type: any, defaultValue: any) => {
        return item && type in item && item[type] ? item[type] : defaultValue;
    };

    let tmpLocations = {} as any;

    for (let p = 0; p < points.length; p++) {
        const onePoint = points[p];

        const loc = getItem(onePoint, projectDataType.PointId, null);
        if (loc) {
            if (!(loc in tmpLocations)) {
                tmpLocations[loc] = {
                    Location: {
                        Name: loc,
                        Task: [] as any
                    },
                    x: getItem(onePoint, projectDataType.X, ''),
                    y: getItem(onePoint, projectDataType.Y, ''),
                    z: getItem(onePoint, projectDataType.Z, '')
                };
            }

            const tasks = getItem(onePoint, 'parsed', []);
            for (let task of tasks) {
                tmpLocations[loc].Location.Task.push({
                    TaskType: task
                });
            }
        }
    }

    return tmpLocations;
};

export const makeLocationArray = (tmpLocations: any) => {
    let locationArray = [] as any;
    Object.keys(tmpLocations).map((item: any) => {
        const oneloc = tmpLocations[item];
        if (oneloc && oneloc.Location && oneloc.Location.Name && oneloc.Location.Task) {
            let newItem = {
                Name: oneloc.Location.Name,
                Point: {
                    x: oneloc.x,
                    y: oneloc.y,
                    z: oneloc.z
                },
                Tasks: [] as any
            };

            for (let t = 0; t < oneloc.Location.Task.length; t++) {
                const oneTask = oneloc.Location.Task[t];
                if (oneTask && oneTask.TaskType && oneTask.TaskType.TaskTypeId) {
                    newItem.Tasks.push({
                        TaskTypeId: oneTask.TaskType.TaskTypeId
                    });
                }
            }

            locationArray.push(newItem);
        }
    });

    return locationArray;
};

export const filterLocationTasks = (item: any, locations: any[]) => {
    let ret = [] as any;

    for (let p = 0; p < item?.Tasks?.length; p++) {
        const oneP = item.Tasks[p];
        const lol = locations.filter((lc: any) => {
            return lc.LocationId == oneP?.Location?.LocationId;
        }) as any;
        const locItem = lol?.length > 0 ? lol[0] : null;
        const tix = locItem?.Task?.findIndex((tss: any) => {
            return oneP?.TaskId && tss?.TaskId == oneP?.TaskId;
        });
        if (tix >= 0 && tix < locItem.Task.length) {
            ret.push({
                ...locItem.Task[tix],
                Location: { ...locItem, Task: undefined }
            });
        }
    }

    return ret;
};

export const filterLocations = (item: any, locations: any[]) => {
    let ret = [] as any;
    let locs = {} as any;
    for (let p = 0; p < item?.Tasks?.length; p++) {
        const oneP = item.Tasks[p];

        const loc_id = oneP?.Location?.LocationId;
        if (!(loc_id in locs)) {
            locs[loc_id] = [];
        }
        locs[loc_id].push(oneP.TaskId);
    }

    Object.keys(locs).map((loc_id: any) => {
        const loc = locations.filter((lc: any) => {
            return lc.LocationId == loc_id;
        }) as any;
        const locItem = loc?.length > 0 ? loc[0] : null;
        if (locItem) {
            ret.push({
                ...locItem,
                Task: locItem?.Task.filter((ts: any) => {
                    return locs[loc_id]?.includes(ts.TaskId);
                })
            });
        }
    });
    return ret;
};
